<p-button *ngIf="!isGroupRendered && !disabled && !disabledByEvent"
    [outlined]="true" 
    label="Duplicate" 
    icon="pi pi-clone"
    (onClick)="onDuplicateClick(params)">
</p-button>